module.exports = __webpack_public_path__ + "img/capricorn.7696171b.svg";